import { Container, ContainerCard, Content } from "./styles";

import Image from "../../images/image(7).png";
import Card from "../card";

const RealestateLaw = () => {
  const description = [
    {
      text: "Assessoria para condomínios",
    },
    {
      text: "Contratos imobiliários",
    },
    {
      text: "Despejo e locação",
    },
    {
      text: "Distrato de compra e venda",
    },
    {
      text: "Regularização de Imóveis",
    },
    {
      text: "Usucapião Judicial e Extrajudicial",
    },
    {
      text: "Ações Possessórias - Imissão, Reintegração e Manutenção de Posse",
    },
    {
      text: "Penhoras e Gravames na Matrícula",
    },
    {
      text: "Due Diligence Imobiliária",
    },
  ];
  return (
    <Container>
      <Content>
        <h1>Direito Imobiliário</h1>
        <p>
          Atuamos na defesa e orientação de clientes em questões que envolvem
          bens imóveis, oferecendo suporte jurídico para resolver conflitos,
          prevenir riscos e garantir segurança em negociações, contratos e
          litígios imobiliários.
        </p>

        <ContainerCard>
          <Card image={Image} title="" description={description} />
        </ContainerCard>
      </Content>
    </Container>
  );
};

export default RealestateLaw;
